
import MoneyForbidden from "../../../assets/duotone/MoneyForbidden.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoneyForbiddenIcon({ className, dataTestid = "MoneyForbiddenIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MoneyForbidden data-testid={dataTestid} className={classes} {...rest} />
  );
}
